<template>
  <!-- 产品投票管理 -->
  <div class="page-container">
    <!-- 数据卡片 -->
    <div class="page-card">
      <!-- 搜索栏 -->
      <div class="page-card__header">
        <el-row>
          <el-col :span="6">
            <span style="padding-right: 20px"> 登记产品（共{{ aSum }}个）</span>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" @click="addProduct">添加产品</el-button>
          </el-col>
          <el-col :span="3">
            <el-button type="primary" @click="to_examine">{{
              verify_title
            }}</el-button>
          </el-col>
          <el-col :span="12">
            <el-input v-model="input">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="serach"
              ></el-button>
            </el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 表格内容 -->
      <div class="page-card__body">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column width="60px" prop="id" label="ID"></el-table-column>
          <el-table-column prop="company" label="公司名称"></el-table-column>
          <el-table-column prop="name" label="产品名称"></el-table-column>
          <el-table-column prop="info" label="一句话介绍"></el-table-column>
          <el-table-column prop="linkman" label="联系人"></el-table-column>
          <el-table-column prop="position" label="职务"></el-table-column>
          <el-table-column prop="tel" label="电话"></el-table-column>
          <el-table-column prop="images" label="图片">
            <template slot-scope="scope">
              <div style="display: flex; gap: 5px">
                <el-image
                  v-for="(img, index) in scope.row.images"
                  :key="index"
                  style="width: 100px; height: 100px"
                  :src="ImagesUri + img.trim()"
                  fit="contain"
                  :preview-src-list="getPreviewImages(scope.row.images)"
                >
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="company_images" label="公司图片">
            <template slot-scope="scope">
              <div style="display: flex; gap: 5px">
                <el-image
                  v-for="(img, index) in scope.row.company_images"
                  :key="index"
                  style="width: 100px; height: 100px"
                  :src="ImagesUri + img.trim()"
                  fit="contain"
                  :preview-src-list="getPreviewImages(scope.row.company_images)"
                >
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="填写时间"
            sortable
          ></el-table-column>

          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.verify == 0"
                type="text"
                @click="VerifyClick(scope.row)"
                >审核</el-button
              >

              <el-button type="text" @click="EditClick(scope.row)"
                >编辑</el-button
              >

              <el-button type="text" @click="handleClick(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="aSum"
        :page-count="pageCount"
        :current-page.sync="currentPage"
        background
        layout="prev, pager, next,jumper"
      >
      </el-pagination>
    </div>

    <!-- 添加/修改产品弹窗 -->
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="EditVisible"
      title="添加/修改产品"
    >
      <el-form ref="updateList" :model="updateList_s" :rules="rules">
        <el-row>
          <div
            style="
              background-color: #eeeeee;
              height: 30px;
              line-height: 30px;
              padding-left: 10px;
              font-weight: bold;
            "
          >
            公司信息
          </div>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="微信用户" prop="wx_user">
              <el-input v-model="updateList_s.wx_user" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="票数" prop="vote">
              <el-input v-model="updateList_s.vote" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="类型" prop="type">
              <br />
              <el-radio-group v-model="updateList_s.type">
                <el-radio :label="1">产品</el-radio>
                <el-radio :label="2">设备</el-radio>
                <el-radio :label="3">自动化</el-radio>
                <el-radio :label="4">其他</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="审核" prop="verify">
              <br />
              <el-radio-group v-model="updateList_s.verify">
                <el-radio :label="0">未审核</el-radio>
                <el-radio :label="1">审核</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="18">
            <el-form-item label="公司名" prop="company">
              <el-input v-model="updateList_s.company" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="公司简称" prop="abbreviation">
              <el-input v-model="updateList_s.abbreviation" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="联系人" prop="linkman">
              <el-input v-model="updateList_s.linkman" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="职位" prop="position">
              <el-input v-model="updateList_s.position" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="电话" prop="tel">
              <el-input v-model="updateList_s.tel" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="公司介绍" prop="company_info">
          <el-input
            type="textarea"
            :rows="8"
            placeholder="请输入内容"
            v-model="updateList_s.company_info"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="公司图片" prop="images">
          <el-upload
            :action="imagesrc"
            :file-list="p_fileList"
            :on-success="P_handleListSuccess"
            :on-remove="p_handleRemove"
            :before-upload="beforeAvatarUpload"
            list-type="picture-card"
            :headers="headers"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <el-row>
          <div
            style="
              background-color: #eeeeee;
              height: 30px;
              line-height: 30px;
              padding-left: 10px;
              font-weight: bold;
            "
          >
            产品信息
          </div>
        </el-row>

        <el-form-item label="产品名称" prop="name">
          <el-input v-model="updateList_s.name" />
        </el-form-item>

        <el-form-item label="一句话介绍产品" prop="info">
          <el-input v-model="updateList_s.info" />
        </el-form-item>

        <el-form-item label="产品详细描述" prop="desc">
          <el-input
            type="textarea"
            :rows="8"
            placeholder="产品优势等"
            v-model="updateList_s.desc"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="使用场景" prop="scenarios">
          <el-input
            type="textarea"
            :rows="2"
            placeholder="请输入内容"
            v-model="updateList_s.scenarios"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="产品前景" prop="prospect">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="updateList_s.prospect"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="产品图片" prop="images">
          <el-upload
            :action="imagesrc"
            :file-list="fileList"
            :on-success="handleListSuccess"
            :on-remove="handleRemove"
            :before-upload="beforeAvatarUpload"
            list-type="picture-card"
            :headers="headers"
          >
            <i slot="default" class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel()"> 取消</el-button>
        <el-button type="primary" @click="updateSumbit()"> 保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  data() {
    return {
      ImagesUri:
        "https://cloudexhibition.oss-cn-shenzhen.aliyuncs.com/product_vote_images/",
      tableData: [],
      pageCount: 1,
      // 每页显示条目数 pagesize
      pagesize: 10,
      currentPage: 1,
      aSum: 0,
      input: "",
      updateList: [],
      EditVisible: false,
      rules: {
        name: [{ required: true, message: "此字段为必填", trigger: "blur" }],
        company: [{ required: true, message: "此字段为必填", trigger: "blur" }],
        linkman: [{ required: true, message: "此字段为必填", trigger: "blur" }],
        position: [
          { required: true, message: "此字段为必填", trigger: "blur" },
        ],
        tel: [{ required: true, message: "此字段为必填", trigger: "blur" }],
        company_info: [
          { required: true, message: "此字段为必填", trigger: "blur" },
        ],
        info: [{ required: true, message: "此字段为必填", trigger: "blur" }],
        desc: [{ required: true, message: "此字段为必填", trigger: "blur" }],
      },
      imagesrc: this.baseUrl + "/admin/uploadfile/product_vote_images/",
      headers: { Authorization: "JWT " + localStorage.getItem("adminToken") },
      fileList: [],
      p_fileList: [],
      verify_data: false,
      updateList_s: "",
      verify_title: "查看未审核",
    };
  },
  mounted() {
    // 页面加载时获取数据
    this.type = this.$route.query.type;
    this.getData();
  },
  beforeRouteUpdate(to, from, next) {
    // 路由更新时重新获取数据
    this.type = to.query.type;
    this.getData();
    next();
  },
  methods: {
    // 获取产品投票列表数据
    getData() {
      let url = this.baseUrl + "/admin/product_vote/";

      api.fetchData(url).then((res) => {
        // 产品图
        for (let i = 0; i < res.results.length; i++) {
          if (res.results[i].images !== "" && res.results[i].images !== null) {
            res.results[i].images = res.results[i].images.split(",");
          } else {
            res.results[i].images = [];
          }
        }

        // 公司图
        for (let i = 0; i < res.results.length; i++) {
          if (
            res.results[i].company_images !== "" &&
            res.results[i].company_images !== null
          ) {
            res.results[i].company_images =
              res.results[i].company_images.split(",");
          } else {
            res.results[i].company_images = [];
          }
        }

        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    // 审核筛选切换
    to_examine() {
      let url = this.baseUrl + "/admin/product_vote/?verify=0";
      if (this.verify_data) {
        url = this.baseUrl + "/admin/product_vote/";
      } else {
        url = this.baseUrl + "/admin/product_vote/?verify=0";
      }

      api.fetchData(url).then((res) => {
        // 产品图
        for (let i = 0; i < res.results.length; i++) {
          if (res.results[i].images !== "" && res.results[i].images !== null) {
            res.results[i].images = res.results[i].images.split(",");
          } else {
            res.results[i].images = [];
          }
        }

        // 公司图
        for (let i = 0; i < res.results.length; i++) {
          if (
            res.results[i].company_images !== "" &&
            res.results[i].company_images !== null
          ) {
            res.results[i].company_images =
              res.results[i].company_images.split(",");
          } else {
            res.results[i].company_images = [];
          }
        }

        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
        this.verify_data == false
          ? (this.verify_data = true)
          : (this.verify_data = false);
        if (this.verify_data == false) {
          this.verify_title = "查看未审核";
        } else {
          this.verify_title = "查看所有";
        }
      });
    },

    // 搜索产品
    serach() {
      let verify;
      if (this.verify_data == false) {
        verify = 1;
      } else {
        verify = 0;
      }
      let url =
        this.baseUrl +
        "/admin/product_vote/?" +
        "search=" +
        this.input +
        "&verify=" +
        verify;
      api.fetchData(url).then((res) => {
        // 产品图
        for (let i = 0; i < res.results.length; i++) {
          if (res.results[i].images !== "" && res.results[i].images !== null) {
            res.results[i].images = res.results[i].images.split(",");
          } else {
            res.results[i].images = [];
          }
        }

        // 公司图
        for (let i = 0; i < res.results.length; i++) {
          if (
            res.results[i].company_images !== "" &&
            res.results[i].company_images !== null
          ) {
            res.results[i].company_images =
              res.results[i].company_images.split(",");
          } else {
            res.results[i].company_images = [];
          }
        }
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    // 分页切换
    handleCurrentChange(val) {
      let url =
        this.baseUrl +
        "/admin/product_vote/?page=" +
        val +
        "&search=" +
        this.input;

      api.fetchData(url).then((res) => {
        // 产品图
        for (let i = 0; i < res.results.length; i++) {
          if (res.results[i].images !== "" && res.results[i].images !== null) {
            res.results[i].images = res.results[i].images.split(",");
          } else {
            res.results[i].images = [];
          }
        }

        // 公司图
        for (let i = 0; i < res.results.length; i++) {
          if (
            res.results[i].company_images !== "" &&
            res.results[i].company_images !== null
          ) {
            res.results[i].company_images =
              res.results[i].company_images.split(",");
          } else {
            res.results[i].company_images = [];
          }
        }
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = val;
      });
    },

    // 删除产品
    handleClick(row) {
      this.$confirm("将删除此条信息，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let a_id = row.id;
        let url = this.baseUrl + "/admin/product_vote/" + a_id + "/";
        api.deleteData(url).then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getData();
        });
      });
    },

    // 审核产品
    VerifyClick(row) {
      this.$confirm("将通过审核产品，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let a_id = row.id;
        let url = this.baseUrl + "/admin/product_vote/" + a_id + "/";
        api.patchData(url, { verify: 1 }).then((res) => {
          this.$message({
            message: "审核成功",
            type: "success",
          });
          this.getData();
        });
      });
    },
    // 打开编辑弹窗
    EditClick(row) {
      this.initImage(row);
      this.EditVisible = true;
      this.updateList_s = JSON.parse(JSON.stringify(row));
    },
    // 修改提交
    updateSumbit() {
      let url =
        this.baseUrl + "/admin/product_vote/" + this.updateList_s.id + "/";
      this.$refs["updateList"].validate((valid) => {
        // 图片
        const images = this.fileList.map((item) => item.name).join(",");
        this.updateList_s.images = images;
        const company_images = this.p_fileList
          .map((item) => item.name)
          .join(",");
        this.updateList_s.company_images = company_images;

        if (valid) {
          if (this.updateList_s.id) {
            api.patchData(url, this.updateList_s).then((response) => {
              if (response.status === 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.EditVisible = false;
                this.fileList = [];
                this.p_fileList = [];
                this.getData();
              }
            });
          } else {
            let postUrl = this.baseUrl + "/admin/product_vote/";
            api.postData(postUrl, this.updateList_s).then((response) => {
              if (response.id) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.EditVisible = false;
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    // 打开添加产品弹窗
    addProduct() {
      this.EditVisible = true;
      this.updateList = {};
      this.fileList = [];
      this.p_fileList = [];
      this.updateList_s = {};
    },
    // 取消弹窗
    cancel() {
      this.EditVisible = false;
    },

    // 删除产品图片上传
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    // 修改产品图片上传成功
    handleListSuccess(res, file) {
      this.fileList.push({
        name: file.response.filename,
        url: this.ImagesUri + file.response.filename,
      });
    },

    // 删除公司图片上传
    p_handleRemove(file, fileList) {
      this.p_fileList = fileList;
    },
    // 修改公司图片上传成功
    P_handleListSuccess(res, file) {
      this.p_fileList.push({
        name: file.response.filename,
        url: this.ImagesUri + file.response.filename,
      });
    },

    // 上传前校验图片格式
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
      }

      return isJPG;
    },
    // 初始化图片列表
    initImage(row) {
      this.fileList = [];
      this.p_fileList = [];
      // 产品图
      if (row.images != null && row.images != "") {
        let imgs = row.images;
        for (var i of imgs) {
          this.fileList.push({ name: i, url: this.ImagesUri + i });
        }
      }

      // 公司图
      if (row.company_images != null && row.company_images != "") {
        let imgs = row.company_images;
        for (var i of imgs) {
          this.p_fileList.push({ name: i, url: this.ImagesUri + i });
        }
      }
    },

    // 图片放大预览
    getPreviewImages(imagesStr) {
      return imagesStr.map((img) => this.ImagesUri + img);
    },
  },
};
</script>

<style scoped>
::v-deep .vue-html5-editor > .content {
  max-height: 600px;
}
</style>

<style>
/* 修复线上图片预览拉伸问题：强制按比例显示 */
.el-image-viewer__wrapper .el-image-viewer__canvas img {
  object-fit: contain !important;
  max-width: 90vw !important;
  max-height: 90vh !important;
  width: auto !important;
  height: auto !important;
}

/* 修复上传框内已上传图片拉伸问题 */
.el-upload-list--picture-card .el-upload-list__item-thumbnail {
  object-fit: contain !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/product_vote.vue